module.exports = __webpack_public_path__ + "img/IMG_1853_min.51d7b67a.jpg";